import { Box, Modal, Slide, Button, useMediaQuery } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { ToolContext } from '../../../core/context/ToolContext';
import { domain, env } from '../../../core/Env';
import { rqx } from '../../../core/request/API';

const PlcyIcons = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M36.6665 9.99981V14.0331C36.6665 16.6665 34.9998 18.3331 32.3665 18.3331H26.6665V6.68314C26.6665 4.83314 28.1832 3.31648 30.0332 3.33314C31.8498 3.34981 33.5165 4.08314 34.7165 5.28314C35.9165 6.49981 36.6665 8.16648 36.6665 9.99981Z" fill="#003F2E"/>
            <path d="M3.3335 11.6663V34.9997C3.3335 36.383 4.90016 37.1663 6.00016 36.333L8.85016 34.1997C9.51683 33.6997 10.4502 33.7663 11.0502 34.3663L13.8168 37.1497C14.4668 37.7997 15.5335 37.7997 16.1835 37.1497L18.9835 34.3497C19.5668 33.7663 20.5002 33.6997 21.1502 34.1997L24.0002 36.333C25.1002 37.1497 26.6668 36.3663 26.6668 34.9997V6.66634C26.6668 4.83301 28.1668 3.33301 30.0002 3.33301H11.6668H10.0002C5.00016 3.33301 3.3335 6.31634 3.3335 9.99967V11.6663Z" fill="#DAE8DA"/>
            <path d="M20 20.4326H15C14.3167 20.4326 13.75 20.9993 13.75 21.6826C13.75 22.366 14.3167 22.9326 15 22.9326H20C20.6833 22.9326 21.25 22.366 21.25 21.6826C21.25 20.9993 20.6833 20.4326 20 20.4326Z" fill="#003F2E"/>
            <path d="M15 16.2666H20C20.6833 16.2666 21.25 15.6999 21.25 15.0166C21.25 14.3333 20.6833 13.7666 20 13.7666H15C14.3167 13.7666 13.75 14.3333 13.75 15.0166C13.75 15.6999 14.3167 16.2666 15 16.2666Z" fill="#003F2E"/>
            <path d="M9.94987 13.3496C9.01654 13.3496 8.2832 14.0996 8.2832 15.0163C8.2832 15.9329 9.0332 16.6829 9.94987 16.6829C10.8665 16.6829 11.6165 15.9329 11.6165 15.0163C11.6165 14.0996 10.8665 13.3496 9.94987 13.3496Z" fill="#003F2E"/>
            <path d="M9.94987 20.0166C9.01654 20.0166 8.2832 20.7666 8.2832 21.6833C8.2832 22.5999 9.0332 23.3499 9.94987 23.3499C10.8665 23.3499 11.6165 22.5999 11.6165 21.6833C11.6165 20.7666 10.8665 20.0166 9.94987 20.0166Z" fill="#003F2E"/>
        </svg>
    )
}

export const PlcyPermission = () => {
    const sm = useMediaQuery('(max-width:500px)')

    const { tool_state } = useContext(ToolContext)
    const { __SESSION } = tool_state

    const [open, setOpen] = useState(false)
    
    const handleClose = async() => {
        try {
            window.open(`${domain('biz').url}/sso/account/auth?ainfo=${encodeURI(JSON.stringify(__SESSION.data.ainfo))}&ref=policy`, '_blank').focus()
        } catch (error) {
            window.location.href = `${domain('biz').url}/sso/account/auth?ainfo=${encodeURI(JSON.stringify(__SESSION.data.ainfo))}&ref=policy`;
        }
    };

    useEffect(() => {
        const __init = async() => {
            // FOR REGULAR USER ONLY IN BUSINESS
            let uaccessBiz = await rqx.get(`<<global>>/${env()}/roleaccess/uap`, {aid: __SESSION.data.ainfo.aid, tid:env() === 'prod' ? 103:13})
            if (!open && uaccessBiz[0].role_name === 'Regular User') {
                let res = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/general-maintenance/cloud/policy/polvalidate`, {
                    company_id: __SESSION.data.uaccess[0].company_id, 
                    dept_id:  __SESSION.data.uaccess[0].company_department_id, 
                    user_id: atob(__SESSION.data.ainfo.aid).split('_', 2)[1]
                })
                if (res === 'required') {
                    setOpen(true)
                }
            }
        }
        __init()
        // eslint-disable-next-line 
    }, [open])
    
    return (  
        <Modal open={open} className="noutlined">
            <Slide in={open} direction='up' className="noutlined">
                <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center" px={sm && 2}>
                    <Box width={sm ? '100%' : '456px'} bgcolor="#FFFFFF" px="24px" pb="24px" borderRadius="6px">
                        <Box minHeight="52px"></Box>
                        <Box display="flex" flexDirection="column" gap="20px">
                            <PlcyIcons/>
                            <Box color="#292C2F" fontSize={16} fontWeight={600} lineHeight="20px" >You need to read and agree with the policies of your company.</Box>
                            <Box color="#5B6167" fontSize={14} fontWeight={400} lineHeight="21px" >
                                Read and Agree to the company policies to ensure smooth operations and maintain standards.
                            </Box>
                            <Box width="flex" textAlign="right">
                                <Button variant="contained" disableElevation onClick={handleClose}
                                        sx={{ width:'171px', minHeight:'48px', borderRadius:'6px', bgcolor: '#003022', color: '#FFFFFF', '&:hover': { bgcolor: '#292C2F' } }} 
                                    >
                                    Go to Policies 
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Slide>
        </Modal>
    );
}